<template>
  <div class="pt-5">
    <v-data-table
      :items="solicitudes"
      :headers="headers"
      :loading="loading"
      :server-items-length="totalItems"
      :items-per-page="pagination.itemsPerPage"
      :page="pagination.page"
      no-data-text="Sin solicitudes para mostrar"
      no-results-text="Sin resultados para mostrar"
      loading-text="Cargando..."
      :footer-props="{
        'items-per-page-all-text': 'Todos',
        'items-per-page-text': 'Elementos por página',
      }"
      @update:page="onPageChange"
      @update:items-per-page="onItemsPerPageChange"
    >
      <template v-slot:top>
        <v-row style="padding: 15px;">
          <v-col cols="12" md="8">
            <h2>Resultados de la búsqueda</h2>
          </v-col>
         
        </v-row>
      </template>

      <template #item.ver="{ item }">
        <v-btn icon x-small @click="verSolicitud(item)">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>

      <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
        <div v-if="itemsLength">
          Mostrando {{ pageStart }} - {{ pageStop }} de
          {{ itemsLength }} solicitudes
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    solicitudes: Array,
    loading: Boolean,
    totalItems: Number,
    pagination: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        { text: "ID", value: "id" },
        { text: "Estatus", value: "statusTag" },
        { text: "Fecha Solicitud", value: "fechaCreacion" },
        { text: "Tipo", value: "tipo" },
        { text: "Categoría", value: "categoria" },
        { text: "Cliente", value: "nombre" },
        { text: "Operador", value: "nombreAgente" },
        { text: "Ver", value: "ver" },
      ],
    };
  },
  methods: {
    verSolicitud(solicitud) {
      this.$router.push(`/solicitud/${solicitud.id}`);
    },

    onPageChange(newPage) {
      this.$emit("update:pagination", { ...this.pagination, page: newPage });
    },
    onItemsPerPageChange(newSize) {
      this.$emit("update:pagination", {
        ...this.pagination,
        itemsPerPage: newSize,
        page: 1,
      });
    },
  },
};
</script>

<style scoped>
.theme--light.v-data-table {
  background-color: #fcf2f2;
  border-radius: 20px;
}
</style>
